import styled from '@emotion/styled'

const EmptyTableTitle = styled.div`
	margin-top: 20px;
	font-size: 20px;
	text-align: center;
	max-width: 350px;
`

const EmptyTableSubtitle = styled.div`
	margin-top: 20px;
	margin-bottom: 20px;
	font-size: 14px;
	max-width: 350px;
	text-align: center;
`

const EmptyTableActionButtons = styled.div`
	display: flex;
	button:first-of-type {
		margin-right: 15px;
	}
`

export { EmptyTableActionButtons, EmptyTableSubtitle, EmptyTableTitle }
